var map = {
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (10).jpeg": 38586,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (11).jpeg": 76935,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (12).jpeg": 35432,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (6).jpeg": 34059,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (7).jpeg": 25902,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (8).jpeg": 50597,
	"./WhatsApp Image 2025-09-16 at 6.35.06 PM (9).jpeg": 70376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73095;